import { convertToMapById } from "helpers/convertToMap";
import { convertToObjById } from "helpers/convertToObject";
import { comoDataTanksTypes } from "./comoDataTanksTypes"

const {
  SET_COMO_DATA_TANKS_FILTERS,
  COMO_DATA_TANK_SELECTED,
  GET_COMO_DATA_TANK,
  CREATE_COMO_DATA_TANK,
  MOD_COMO_DATA_TANK,
  DELETE_COMO_DATA_TANK,
  RESET_COMO_DATA_TANK_SELECTED,
  ADD_COMO_DATA_TANK_MODE,
  EDIT_COMO_DATA_TANK_MODE,
  DELETE_COMO_DATA_TANK_MODE,
  CLEAR_COMO_DATA_TANKS,
  GET_BRAND_TANK,
  GET_CAPACITY_TANK,
  SET_CONFIG_FILTER_COMO_DATA_TANKS,
  SET_CONFIG_PAGE_COMO_DATA_TANKS,
  SET_CONFIG_PAGE_SIZE_COMO_DATA_TANKS,
  SET_CONFIG_SORTED_COMO_DATA_TANKS,
} = comoDataTanksTypes

const INITIAL_STATE = {
  comoDataTankSelected: null,
  comoDataTanksObj: {},
  comoDataTanksArr: [],
  brandsTank: [],
  capacitiesTank: [],
  addComoDataTank: true,
  addMode: false,
  deleteMode: false,
  station: {},
  config: {
    page: 0,
    pageSize: 20,
    filtered: [],
    sorted: []
  },
}

export const comoDataTanksReducer = (state = INITIAL_STATE, { type, payload }) => {

  switch (type) {

    case SET_COMO_DATA_TANKS_FILTERS:
      return {
        ...state,
        [payload.key]: payload.data,
      };

    case ADD_COMO_DATA_TANK_MODE:
      return {
        ...state,
        addMode: true,
        deleteMode: false
      }

    case EDIT_COMO_DATA_TANK_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: false
      }

    case DELETE_COMO_DATA_TANK_MODE:
      return {
        ...state,
        addMode: false,
        deleteMode: true
      }

    case GET_COMO_DATA_TANK:
      return {
        ...state,
        comoDataTanksObj: convertToObjById(payload),
        comoDataTanksArr: payload,
      }

    case COMO_DATA_TANK_SELECTED:
      return {
        ...state,
        comoDataTankSelected: payload && state.comoDataTanksObj[payload]
      }

    case RESET_COMO_DATA_TANK_SELECTED:
      return {
        ...state,
        comoDataTankSelected: null,
      }

    case CREATE_COMO_DATA_TANK:
      const addingComoDataTank = [payload, ...state.comoDataTanksArr]
      const newComoData = convertToObjById(addingComoDataTank)
      return {
        ...state,
        comoDataTanksObj: newComoData,
        comoDataTanksArr: addingComoDataTank,
        newComoDataId: payload.id
      }

    case MOD_COMO_DATA_TANK:
      const editedComoDataTanks = {
        ...state.comoDataTanksObj,
        [payload.id]: {
          ...state.comoDataTanksObj[payload.id],
          ...payload
        },
      }
      return {
        ...state,
        comoDataTanksObj: editedComoDataTanks,
        comoDataTanksArr: convertToMapById(editedComoDataTanks),
        comoDataTankSelected: editedComoDataTanks[payload.id]
      }

    case DELETE_COMO_DATA_TANK:
      const dataArray = state.comoDataTanksArr.filter(comoData => comoData.id !== payload)
      return {
        ...state,
        comoDataTanksObj: convertToObjById(dataArray),
        comoDataTanksArr: dataArray
      }

    case CLEAR_COMO_DATA_TANKS:
      return {
        ...state,
        comoDataTankSelected: INITIAL_STATE.comoDataTankSelected,
        comoDataTanksObj: INITIAL_STATE.comoDataTanksObj,
        comoDataTanksArr: INITIAL_STATE.comoDataTanksArr,
        addMode: INITIAL_STATE.addMode,
        deleteMode: INITIAL_STATE.deleteMode,
        station: INITIAL_STATE.station,
        config: INITIAL_STATE.config,
      };

    case GET_BRAND_TANK:
      const brandsMap = payload.map( brand =>  ({...brand, value: brand.name, label: brand.name}))
      return {
        ...state,
        brandsTank: brandsMap,
      };
    case GET_CAPACITY_TANK:
      const capacities= payload.map( capacity =>  ({...capacity, label: String(capacity.capacity)}))
      return {
        ...state,
        capacitiesTank: capacities,
      };

    case SET_CONFIG_FILTER_COMO_DATA_TANKS:
      return {
        ...state,
        config: {
          ...state.config,
          filtered: payload,
          page: 0,
        },
      };

    case SET_CONFIG_PAGE_COMO_DATA_TANKS:
      return {
        ...state,
        config: {
          ...state.config,
          page: payload,
        },
      };

    case SET_CONFIG_PAGE_SIZE_COMO_DATA_TANKS:
      return {
        ...state,
        config: {
          ...state.config,
          pageSize: payload,
          page: 0,
        },
      };

    case SET_CONFIG_SORTED_COMO_DATA_TANKS:
      return {
        ...state,
        config: {
          ...state.config,
          sorted: payload,
          page: 0,
        }
      }

    default:
      return state
  }
}